<template>
  <v-edit-dialog
    ref="dialog"
    v-model="dialog"
  >
    <validation-provider
      v-slot="{ errors }"
      :rules="rules"
    >
      <input
        type="hidden"
        :value="value"
      >
      <span class>{{ value }}</span>
      <v-icon
        small
        style="cursor:edit"
        class="ml-2 mr-2"
      >
        mdi-lead-pencil
      </v-icon>
      <span class="flex-item text-caption error--text">{{ errors[0] }}</span>
    </validation-provider>
    <template #input>
      <validation-provider
        v-slot="{ errors }"
        :rules="rules"
      >
        <v-select
          v-if="type === 'select'"
          :value="value"
          :items="items"
          :error-messages="errors"
          :label="label"
          @input="updateValue"
          @change="updateValue"
        />
        <v-text-field
          v-else
          :value="value"
          :label="label"
          :error-messages="errors"
          single-line
          @change="updateValue"
        />
      </validation-provider>
    </template>
  </v-edit-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'DataTableInputDialog',
  props: {
    type: { type: String, default: 'input' },
    items: { type: Array, default: () => [] as Array<any> },
    rules: { type: String, default: '' },
    label: { type: String, default: '' },
    value: { type: String, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    dialog(val: boolean) {
      if (!val) { this.$emit('input', this.value); }
    },
  },
  methods: {
    updateValue(value: string) {
      this.$emit('input', value);
      // Auto dismiss on selected value in combobox
      if (this.type === 'select') {
        (this.$refs.dialog as Vue & { save: (val: any)=>void }).save(value);
      }
    },
  },
});
</script>
